import { render, staticRenderFns } from "./LicenseReportSettings.vue?vue&type=template&id=6c13270c&scoped=true"
import script from "./LicenseReportSettings.vue?vue&type=script&lang=js"
export * from "./LicenseReportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13270c",
  null
  
)

export default component.exports